/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import { Mousewheel, Keyboard } from 'swiper/modules';
Swiper.use([Mousewheel, Keyboard]);
import customEventsNames from './../customEventsNames';


export function pageScroll() {
    const sectionsSliderSelector = ".slides-container";
    const sectionsSliderWrapperSelector = ".slides-container__wrapper";
    const sectionsSliderSlideSelector = ".scroll";
    const bodyActiveClass = "page-scroll";
    const swiperSpeed = 1000;
    var sectionsSlider;

    var enabled = document.querySelector(sectionsSliderSelector).getAttribute("data-scroll");
    // Convert to boolean
    var isEnabled = enabled === "True" || enabled === "1";

    //Method for adding and removing the swiper classes. 
    const togglePageScrollClasses = function (slider, wrapper, add) {
        if (add) {
            slider.classList.add('swiper');
            wrapper.classList.add('swiper-wrapper');
            document.body.classList.add(bodyActiveClass);

        } else {
            slider.classList.remove('swiper');
            wrapper.classList.remove('swiper-wrapper');
            document.body.classList.remove(bodyActiveClass);

        }
    };

    //Method for getting the index of a slide from it's hash
    const getSlideIndexFromHash = function (hash) {
        hash = hash.replace('#', '');
        const slides = document.querySelectorAll(`${sectionsSliderSelector} ${sectionsSliderSlideSelector}`);
        if (slides) {
            return Array.from(slides).findIndex(slide => slide.dataset.hash == hash);
        }
        return 0;
    }

    //Timeout to flag the body as loading, triggering style changes
    const flagBodyLoaded = function () {
        setTimeout(() => {
            document.body.classList.add('loaded');
        }, 100);
    };

    const getPanelFromHash = (hash) => {
        hash = hash.replace('#', '');
        const panel = document.getElementById(hash);
        if (panel && panel.classList.contains('panel-div')) {
            return panel;
        }

        return null;
    }

    const getDataLayerHashValue = (hashValue, suffix) => {
        //We add 2024 after the hash value so not to confuse any tracking from the old annual report
        if (!hashValue.endsWith(suffix)) {
            hashValue = hashValue + suffix;
        }

        return hashValue;
    }

    const setupPageScroll = function (mediaQuery, initSectionObserver) {
        const initialHash = window.location.hash;
        const panel = getPanelFromHash(initialHash);
        if (mediaQuery.matches && isEnabled) {
            //We are on a large screen, so we initialize Swiper
            const sectionsSliderElement = document.querySelector(sectionsSliderSelector);
            const sectionsSliderWrapperElement = sectionsSliderElement?.querySelector(sectionsSliderWrapperSelector);
            if (sectionsSliderElement && sectionsSliderWrapperElement) {
                togglePageScrollClasses(sectionsSliderElement, sectionsSliderWrapperElement, true);

                //Getting the index of the initial slide from the hash
                let initialIndex = getSlideIndexFromHash(location.hash);
                //If its a panel, get the index from the slide that contains the panel
                if (panel) {
                    initialIndex = getSlideIndexFromHash(panel.closest(sectionsSliderSlideSelector).dataset.hash);
                }

                sectionsSlider = new Swiper(sectionsSliderElement, {
                    slideClass: 'scroll',
                    direction: 'vertical',
                    slidesPerView: 1,
                    initialSlide: initialIndex,
                    speed: swiperSpeed,
                    mousewheel: true,
                    keyboard: {
                        enabled: true
                    },
                    on: {
                        slideChange: function (swiper) {
                            //Update the hash
                            var newHash = swiper.slides[swiper.activeIndex].getAttribute('data-hash');
                            history.replaceState(null, null, '#' + newHash);

                            //Push event to data layer
                            window.dataLayer.push({
                                'event': 'sectionChange',
                                'section': newHash
                            });

                            //Hiding the logo if needed
                            const headerLogo = document.querySelector(".header__logo");
                            if (swiper.activeIndex > 0) {
                                headerLogo.style.display = "none";
                            } else {
                                headerLogo.style.display = "flex";
                            }
                        },
                        init: (swiper) => {
                            //We are waiting a bit with revealing the body, so everything looks good when we do so
                            flagBodyLoaded();

                            var initialSlideHash = swiper.slides[swiper.activeIndex].getAttribute('data-hash');
                            //Push event to data layer
                            window.dataLayer.push({
                                'event': 'sectionChange',
                                'section': initialSlideHash
                            });

                            if (panel) {
                                const buttons = document.querySelector(`.panel-button[data-panel-id="${panel.id}"]`);
                                const button = panel.closest(sectionsSliderSlideSelector)?.querySelector('.panel-button')

                                if (buttons) {
                                    swiper.disable();
                                    buttons.click();
                                } else if (button) {
                                    swiper.disable();
                                    button.click();
                                }
                            }
                        }
                    }
                });


                //Handle anchor click
                const anchors = document.querySelectorAll('a[href^="/#"], a[href^="#"]');
                if (anchors) {
                    anchors.forEach(item => {
                        item.addEventListener('click', e => {
                            if (document.body.classList.contains(bodyActiveClass) && e.target.tagName == 'A' && e.target.hash) {
                                e.preventDefault();
                                const targetElement = document.querySelector(e.target.hash);

                                if (targetElement && targetElement.classList.contains('panel')) {
                                    const parentElement = targetElement.parentElement;
                                    const panelButton = parentElement.querySelector('.panel-button');

                                    if (panelButton) {
                                        let newIndex = sectionsSlider.activeIndex;
                                        newIndex = getSlideIndexFromHash(parentElement.parentElement.getAttribute('data-hash'));
                                        sectionsSlider.slideTo(newIndex, swiperSpeed);
                                        panelButton.click();
                                    }
                                } else {
                                    let newIndex = sectionsSlider.activeIndex;
                                    newIndex = getSlideIndexFromHash(e.target.hash);
                                    sectionsSlider.slideTo(newIndex, swiperSpeed);
                                }
                            }
                        });
                    });
                }

                //Handle panel opening
                document.body.addEventListener(customEventsNames.panelOpened, e => {
                    sectionsSlider.disable();
                });

                //Handle panel closing
                document.body.addEventListener(customEventsNames.panelClosed, e => {
                    sectionsSlider.enable();
                });
            }
        } else {
            //We are on a small screen, so we kill the swiper instance
            if (sectionsSlider) {
                sectionsSlider.destroy();
            }

            const sectionsSliderElement = document.querySelector(sectionsSliderSelector);
            const sectionsSliderWrapperElement = sectionsSliderElement?.querySelector(sectionsSliderWrapperSelector);
            if (sectionsSliderElement && sectionsSliderWrapperElement) {
                togglePageScrollClasses(sectionsSliderElement, sectionsSliderWrapperElement, false);
            }

            const headerLogo = document.querySelector(".header__main");
            headerLogo.style.display = "flex";

            flagBodyLoaded();

            //Sending dataLayer events when a section is scrolled into view, this is only applied if the style of the annual report is also 2024 to not break old tracking
            if (initSectionObserver && document.body.classList.contains('report--2024')) {

                //If the page is scrolling from an anchor click, we need to set a flag to disable intersecting, otherwise we will send "false" dataLayer events
                let isScrollingFromAnchor = false;
                const anchors = document.querySelectorAll('a[href^="/#"], a[href^="#"]');
                if (anchors) {
                    anchors.forEach(item => {
                        item.addEventListener('click', e => {

                            //We "pause" intersection observing for a second while the page scrolls
                            isScrollingFromAnchor = true;
                            setTimeout(() => {
                                isScrollingFromAnchor = false;
                               
                            }, 1000);

                            //And because the intersection oberservation is paused, we need to manually add this to the data layer
                            window.dataLayer.push({
                                'event': 'sectionChange',
                                'section': getDataLayerHashValue(e.target.hash.replace('#',''),'2024') //Insert the id of the target here
                            });
                        });
                    });
                }

                //Handle intersection of any section with a hash so we can add a dataLayer event for tracking
                const sections = document.querySelectorAll('[data-hash');
                if (sections) {

                    const observer = new IntersectionObserver((entries, observer) => {
                        entries.forEach(entry => {
                            if (isScrollingFromAnchor) return false;

                            if (entry.isIntersecting) {
                                window.dataLayer.push({
                                    'event': 'sectionChange',
                                    'section': getDataLayerHashValue(entry.target.dataset.hash,'2024')
                                });

                                // console.log(window.dataLayer);
                            }
                        });
                    },
                        {
                            threshold: 0.5
                        });

                    sections.forEach(section => {
                        observer.observe(section);
                    })
                }

            }
        }

    }


    const init = function () {
        //Setting up a media query for listening to page width
        const mediaQuery = window.matchMedia("(min-width:992px)");
        mediaQuery.addEventListener("change", function () {
            setupPageScroll(mediaQuery, false);
        });

        //Running setup code
        setupPageScroll(mediaQuery, true);
    }

    init();
}
